/** @format */
import { MediaQuery } from '@mpb-com/feather/helpers/media-queries';
import { css } from 'styled-components';

import { desktop } from '@toucan/helpers/media-queries';

import { getGutterSize } from '@toucan/client/shared/components/constrained-wrapper/style-helpers';
import { SCROLLBAR_HEIGHT } from '@toucan/client/shared/components/scrollable-carousel/scrollable-carousel.styles';

export const styles = css`
    padding-top: var(--layout-spacing-48);

    .model-recommendations-carousel {
        .scrollable-carousel-inner {
            padding: 0;
        }

        .scrollable-carousel-list {
            padding: var(--layout-spacing-24) 0
                calc(var(--layout-spacing-48) + ${SCROLLBAR_HEIGHT});
            margin: 0;
        }

        .scrollable-carousel-item:not(:last-child) {
            padding-right: var(--layout-spacing-24);
        }
    }

    .recommendations-carousel-heading {
        margin-bottom: var(--layout-spacing-8);
    }

    .model-recommendations-card-link {
        width: 32rem;
        position: relative;
        height: 100%;
    }

    .scrollable-carousel-arrow {
        visibility: hidden;
    }

    ${desktop(css`
        .scrollable-carousel-arrow {
            visibility: visible;
        }
    `)}

    .skeleton-heading {
        max-width: 50rem;
    }

    ${[
        MediaQuery.DESKTOP,
        MediaQuery.LARGE_DESKTOP,
        MediaQuery.LARGE_TABLET,
        MediaQuery.SMALL_TABLET,
        MediaQuery.MOBILE,
        MediaQuery.SMALL_MOBILE,
    ].map(
        (mediaQuery) => css`
            @media ${mediaQuery} {
                .model-recommendations-carousel {
                    margin: 0 calc(${getGutterSize(mediaQuery)} * -1);

                    .scrollable-carousel-arrow--previous {
                        left: ${getGutterSize(mediaQuery)};
                    }

                    .scrollable-carousel-arrow--next {
                        right: ${getGutterSize(mediaQuery)};
                    }

                    .scrollable-carousel-outer {
                        padding: 0 ${getGutterSize(mediaQuery)};
                    }
                }
            }
        `
    )}
`;
